import PasswordResetRequest from "../domain/PasswordResetRequest";
import WsService from "./WsService";

const ENDPOINT_BASE = "/authentication";

export default class PasswordResetService {

    static resetPassword(username, phoneNumber) {

        let endpoint = ENDPOINT_BASE + "/reset-password";

        let resetRequest = PasswordResetRequest.toJson(username, phoneNumber);

        return WsService.post(endpoint, resetRequest, 200).then(
            response => {
                return 'success';
            },
            response => {
                return response;
            }
        )

    }

}